declare const window: any;

export const checkScriptLoader = async (
    maxCount: number = 10
): Promise<boolean> => {
    let count = 0;
    while (!window.ScriptLoader) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        count++;
        if (count > maxCount * 10) {
            return false;
        }
    }
    return true;
};
